module.exports = __webpack_public_path__ + "img/fd59f25f19417413b4e0043021d85da0.png";